import React, { useState, useEffect } from 'react';
import { SearchSelect } from '@td-client-frontend/common';
import { useDebounce } from 'use-debounce';
import { useTemplateList } from '../hooks/useTemplateList';

interface TemplateSelectProps {
  onSelected: React.Dispatch<React.SetStateAction<string>>;
  selectedValue?: string | null;
  label?: string;
  error?: string;
  validate?: (searchValue: string, options: templateSearchOptions[]) => void;
}

export interface templateSearchOptions {
  label: string;
  value: string;
}

export function TemplateSelect({ onSelected, label = '' }: TemplateSelectProps) {
  const [search, setSearch] = useState<string>('');
  const [error, setError] = useState<string | undefined>(undefined);
  const [touched, setTouched] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<string>('');

  const [debouncedSearch] = useDebounce(search, 750);
  const { data: templateList = [], isFetching } = useTemplateList({ search: debouncedSearch });

  const options: templateSearchOptions[] = templateList.map((name) => ({ label: name, value: name }));

  const handleSearchChange = (searchValue: string) => {
    setTouched(true);
    setSearch(searchValue);
  };

  const handleSelect = ({ value }: templateSearchOptions) => {
    onSelected(value);
    setSearch(value);
    setSelectedTemplate(value);
  };

  useEffect(() => {
    if (touched) {
      if (selectedTemplate !== search || !search.length) {
        setError('Please select Template Name');
        onSelected('');
        setSelectedTemplate('');
      } else {
        setError('');
      }
    }
  }, [touched, search, onSelected, selectedTemplate]);

  useEffect(() => {
    if (templateList?.length) {
      if (!templateList?.includes(search)) onSelected('');
      else onSelected(search);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateList, search]);

  return (
    <div className="flex w-full items-center mt-4 min-w-24 px-6">
      <SearchSelect
        label={label}
        name="template-search-select"
        value={search}
        isError={!!error?.length}
        error={error}
        options={options}
        onSearchChange={handleSearchChange}
        onSelect={handleSelect}
        placeholder="Select Template Name"
        dataIsLoading={isFetching}
        efficientValueLength={0}
      />
    </div>
  );
}
